import { Box } from "@chakra-ui/react";
import { FC } from "react";

const Dot: FC = () => (
  <Box
    w="20px"
    h="20px"
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
  >
    <Box w="6px" h="6px" bg="#d7e2ea" borderRadius="full" />
  </Box>
);

export default Dot;
